import { getAuth } from "firebase/auth";

import firebaseApp from "../lib/firebaseApp";

export const getFirebaseAuth = () => getAuth(firebaseApp);
